module.exports = "<igo-context-form *ngIf=\"context\"\r\n   [btnSubmitText]=\"'igo.context.save' | translate\"\r\n   [context]=\"context\"\r\n   (submitForm)=\"submitForm.emit($event)\">\r\n</igo-context-form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/context/context-edit/context-edit.component.html
// module id = 972
// module chunks = 0